
import { Component, Prop, Vue } from "vue-property-decorator";
import HorizontalScrollList from "./horizontalScrollList.vue";

@Component({
  components: {
    HorizontalScrollList,
  },
})
export default class ScrollableBanner extends Vue {
  @Prop({ required: false, default: "" }) private title!: string;
  @Prop({ required: true }) private items!: any[];
  @Prop({ required: false }) private nItems?: number;
  @Prop({ required: false }) private viewMoreUrl?: string;
  @Prop({ required: false }) private centerFirstCard?: boolean;
  @Prop({ required: false, default: true }) private showScrollMobile?: boolean;
  @Prop({ required: false, default: () => ({}) })
  @Prop({ required: false, default: () => ({}) }) bannerListStyle!: object;
  @Prop({ required: false, default: false }) private titleWhite!: boolean;
  @Prop({ required: false, default: false }) private darkMode!: boolean;

  private get itemsToShow() {
    return this.nItems && this.items
      ? this.items.slice(0, this.nItems)
      : this.items;
  }

  private get canViewMore() {
    return this.viewMoreUrl && this.items.length > 1;
  }
}
